// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vBRi","clinicsSelect":"styles_clinicsSelect__1D6_Z"};